import { RiFileExcel2Line /* , RiInboxArchiveLine */ } from "react-icons/ri"
import Excel from "./zoneExcel"
// import { S3Browser } from "./zoneS3"

function ImportArea() {

  return (
    <>
      <div className="text-center">
        <ul
          className="flex flex-col flex-wrap justify-center pl-0 mt-2 mb-5 list-none border-b-0 md:flex-row"
          role="tablist"
          data-te-nav-ref>
          <li role="presentation">
            <a
              href="#tabs-excel"
              className="my-2 block border-x-0 border-t-0 border-b-2 border-transparent px-7 pt-4 pb-3.5 text-xs font-medium uppercase leading-tight text-neutral-500 hover:isolate hover:border-transparent hover:bg-neutral-100 focus:isolate focus:border-transparent data-[te-nav-active]:border-emerald data-[te-nav-active]:text-emerald dark:text-neutral-400 dark:hover:bg-transparent data-[te-nav-active]:border-emerald-400 data-[te-nav-active]:text-emerald-400"
              data-te-toggle="pill"
              data-te-target="#tabs-excel"
              data-te-nav-active
              role="tab"
              aria-controls="tabs-excel"
              aria-selected="true"
              >
                <div className='flex items-center gap-2'>
                  <RiFileExcel2Line size={20}/><span className=''>Excel</span>
                </div>
            </a>
          </li>
          {/* <li role="presentation">
            <a
              href="#tabs-files"
              className="focus:border-transparen my-2 block border-x-0 border-t-0 border-b-2 border-transparent px-7 pt-4 pb-3.5 text-xs font-medium uppercase leading-tight text-neutral-500 hover:isolate hover:border-transparent hover:bg-neutral-100 focus:isolate data-[te-nav-active]:border-primary data-[te-nav-active]:text-primary dark:text-neutral-400 dark:hover:bg-transparent dark:data-[te-nav-active]:border-primary-400 dark:data-[te-nav-active]:text-primary-400"
              data-te-toggle="pill"
              data-te-target="#tabs-files"
              role="tab"
              aria-controls="tabs-files"
              aria-selected="false"
              >
                <div className='flex items-center gap-2'>
                  <RiInboxArchiveLine size={20}/><span className=''>Files</span>
                </div>
            </a>
          </li> */}
        </ul>
        <div className="mb-6">
          <div
            className="hidden opacity-0 opacity-100 transition-opacity duration-150 ease-linear data-[te-tab-active]:block"
            id="tabs-excel"
            role="tabpanel"
            aria-labelledby="tabs-excel-tab"
            data-te-tab-active>
            <Excel />
          </div>
          {/* <div
            className="hidden opacity-0 transition-opacity duration-150 ease-linear data-[te-tab-active]:block"
            id="tabs-files"
            role="tabpanel"
            aria-labelledby="tabs-files-tab">
            <S3Browser />
          </div> */}
        </div>
      </div>


     {/* <div className="h-[64rem]">
        Testing
     </div> */}
    </>
  );
}

export default ImportArea;
